import { render, staticRenderFns } from "./BlockUi.vue?vue&type=template&id=214c9b08&"
import script from "./BlockUi.vue?vue&type=script&lang=js&"
export * from "./BlockUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports